var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "vue-smart-slider-pip",
      style: { left: _vm.leftPosition.toString().concat("%") },
    },
    [
      _c(
        "small",
        { staticClass: "vue-smart-slider-mark-label" },
        [
          _vm.marker.show !== false
            ? [_vm._v("\n      " + _vm._s(_vm.marker.value) + "\n    ")]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }